import anime from "animejs"
export default () => ({
    open: false,
    init() {
        anime({
            targets: this.$root,
            translateY: '100vh',
            duration:0,
            opacity:0
        });
    },

    async openModal() {
        
        await anime({
            targets: this.$root,
            translateY: '0vh',
            duration:0
        }).finished;
        await anime({
            targets: this.$root,
            opacity: 1,
            duration:200,
            easing:'linear'
        }).finished;
        await anime({
            targets: this.$refs.content,
            opacity: 1,
            duration:200,
            delay:200,
            easing:'linear'
        }).finished;

        
    },
    async onClose(){
        
        await anime({
            targets: this.$refs.content,
            opacity: 0,
            duration:500,
            easing:'linear'
        }).finished;

        console.log('%c%s', 'color: #0088cc', 'done1');
        await anime({
            targets: this.$root,
            opacity: 0,
            duration:500,
            easing:'linear'
        }).finished;

        console.log('%c%s', 'color: #917399', 'done2');
        await anime({
            targets: this.$root,
            translateY: '100vh',
            duration:0
        }).finished;
        
    }
})